import { SaveGInstallmentRequest } from "../g-purchase/GPurchaseViewModel";
import { ItemViewModel1 } from "../ItemViewModel";

export class GVehicleModel {
    public id: number;
    public name: string;
    public description: string;
    public registrationNumber: string;
    public chassisNumber: string;
    public engineNumber: string;
    public bikeEnggPower: string;
    public colour: string;
    public odometer: number;
    public purchaseDate: Date;
    public brand: ItemViewModel1;
    public model: ItemViewModel1;
    public customer: ItemViewModel1;
    public customerEmail: ItemViewModel1;
    public driverName: string;
    public driverPhone: string;
    public customerDiscount: number;
    public saleDetails: any;
    public purchaseDetail: any;
    public tag: ItemViewModel1;
    public tagList: ItemViewModel1[];
    public gStatus: ItemViewModel1;
}


export class SaveBulkInstallmentRequest {

  public id: number;
  public refId: string;
  public uniqueId: string;
  public transactionDate : Date
  public customer : ItemViewModel1;
  public cashAndBank : ItemViewModel1;
  public remarks : string;
  public totalInvoiceAmount : number;
  public pdfInvoiceList: string;
  public totalPaidAmount : number;
  public totalBalance : number;
  public totalAmount : number;
  public bulkInstallments : SaveGInstallmentRequest[];
}